// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getRolesAll = async ({ token, params }: any) => {
   try {
      return await client
         .get(`roles`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getRolesById = async ({ token, params } :any) => {
   try {
      return await client
         .get(`roles/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getRolesHasPermissionById = async ({ token, params }: any) => {
   try {
      return await client
         .get(`roles/permission/${params.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const postCreateRoles = async ({ token, params }: any) => {
   try {
      return await client
         .post(`roles`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateRoles = async ({ token, params, id }: any) => {
   try {
      return await client
         .put(`roles/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteRoles = async ({ token, id }: any) => {
   try {
      return await client
         .delete(`roles/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const postUpdatePermissionRoles = async ({ token, params }: any) => {
   try {
      return await client
         .post(`roles/permission`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};
